import React from 'react';
import { HeroContent } from './hero-content';

// eslint-disable-next-line import/prefer-default-export
export function Hero() {
  return (
    <section
      aria-label="Hero"
      className="relative w-full flex items-center overflow-hidden -mt-20"
      style={{ minHeight: '100dvh' }}
    >
      <img
        src="/assets/hero-bg.webp"
        alt=""
        aria-hidden="true"
        loading="eager"
        decoding="async"
        width={1920}
        height={1080}
        sizes="100vw"
        className="hidden md:block absolute inset-0 w-full h-full object-cover object-right"
      />
      <div className="hero-overlay hidden md:block absolute inset-0" />

      <div className="relative z-10 w-full max-w-7xl mx-auto px-6 md:px-12 py-32 flex flex-col items-center md:items-start">
        <div className="max-w-2xl text-center md:text-left">
          <HeroContent />
        </div>
      </div>
    </section>
  );
}
